export default __webpack_public_path__ + "static/media/prototype.429063b1.svg";